<div  fxLayout="column" fxFlex="100%" fxLayoutGap="10px" style="padding: 20px;">
  <div fxLayout="column">
    <div fxLayout="row" style="position: relative;">
      <span  fxLayoutAlign="space-between center" fxLayout="row" style="font-family: Montserrat, SemiBold;
      font-size: 14px;
      color: #707070;">
      {{ data.heading }}
      </span>
      <mat-icon mat-icon-button pointer [mat-dialog-close]="" style="position: absolute; right:0px; top: -10px; font-size:18px ;color:#707070">close</mat-icon>
    </div>
  </div>
  <mat-divider style="width: 500px;"></mat-divider>
  <div fxLayout="row" style="font-size: 14px !important;font-family: Montserrat !important;color: rgba(0, 0, 0, .87) !important">
    <div fxLayout="column" fxFlex="50%">
      <div fxLayout="row" style="margin-left: 30px;">
        <span fxLayout="column" fxFlex="50%">From</span>
        <span fxLayout="column" fxFlex="50%">{{data.startDate | date}}</span>
      </div>
    </div>
    <div fxLayout="column" fxFlex="50%">
      <div fxLayout="row">
        <span fxLayout="column" fxFlex="50%">To</span>
        <span fxLayout="column" fxFlex="50%">{{data.endDate | date}}</span>
      </div>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between">
    <mat-calendar fxLayout="column" fxFlex="50%" [selected]="data.startDate"
    [maxDate]="data.endDate"
    [startAt]="data.startDate"
    (selectedChange)="onSelect($event, 'start')"></mat-calendar>

    <mat-calendar  fxLayout="column" fxFlex="50%"
    [maxDate]="maxDate"
    [minDate]="data.startDate"
    [startAt]="data.endDate"
    [selected]="data.endDate" (selectedChange)="onSelect($event, 'end')"></mat-calendar>
  </div>
  <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
    <p *ngIf="disableOk" style="font-size: small; color: red;">A maximum date range of 1 year is allowed</p>

    <button 
      [disabled]="disableOk"
      [ngStyle]="{ 'opacity' : disableOk ? '0.5' : '1' }"
      mat-raised-button  
      [mat-dialog-close]="data" 
      cdkFocusInitial 
      (click)="submitDateRange(startDate, endDate)" 
      style="width:90px !important; height:35px !important;background-color: #006EAE !important;color: white !important;">
      OK
    </button>

    <button 
      mat-button 
      [mat-dialog-close]="" 
      style="width: 90px; background: #CFEDFF; height: 35px;">
      Cancel
    </button>
  </div>
</div>